module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  var item = widget.item; 
    ; __append("\n\n")
    ;  if(widget.titleField) { 
    ; __append("\n<div class=\"section\">\n    <span>Название</span>\n    <div\n        data-control-html-name=\"")
    ; __append(escapeFn( widget.titleField ))
    ; __append("\"\n        data-control-type=\"text\"\n        data-control-target=\"")
    ; __append(escapeFn( widget.titleField ))
    ; __append("\"\n        data-control-html-placeholder=\"Введите название\"\n    ></div>\n</div>\n")
    ;  } 
    ; __append("\n\n<div name=\"attributes\"></div>\n")
  }
  return __output.join("");

}